<template>
  <a-form
    ref="formState"
    :model="formState"
    :rules="rules"
    v-bind="{
      labelCol: {
        span: 4,
      },
      wrapperCol: {
        span: 14,
      },
    }"
  >
    <a-form-item label="编号" name="pass">
      <a-input v-model:value="formState.num" type="text" />
    </a-form-item>

    <a-form-item :wrapper-col="{ span: 14, offset: 4 }">
      <a-button type="primary" @click="$confirm(returned,formState)">确认</a-button>
      <a-button style="margin-left: 10px" @click="reset">重置</a-button>
    </a-form-item>
  </a-form>
</template>
<script>
export default {
  data() {
    return {
      returned: null,
      defaultData: {},
      formState: {
        num: "",
        creator: "",
        remark: "",
        userId: "",
      },
    };
  },
  async mounted() {
    let id = this.$route.query.id;
    if (id) {
      this.returned = await new this.$lc.Query("returned")
        .equalTo("objectId", id)
        .first();
      this.formState = { ...this.returned.attributes };
      this.defaultData = { ...this.returned.attributes };
    } else {
      this.returned = new this.$lc.Object("returned");
      let userId = await new this.$lc.User.current().get("objectId");
      this.formState.userId = userId;
    }
  },
  methods: {
    // 重置
    reset() {
      this.formState = { ...this.defaultData };
    },
  },
};
</script>